// dependecies import ==>
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
// assets and scss import ==>
import "./myTransactionsMainContent.scss";
// project file import ==>
import MyTransactionsMainContentHeader from "./MyTransactionsMainContentHeader";
import MyTransactionsTable from "./MyTransactionsTable";
import { addQuery } from "../helper";
import MyTransactionsMainContentFooter from "./MyTransactionsMainContentFooter";
// constant import ==>
import { API_FILTER_LIST, DEFAULT_TRANSACTIONS_PAYLOAD } from "../constants";

const MyTransactionsMainContent = (props) => {
  const {
    transactionsSummary,
    userType,
    clinicId,
    sortOrder,
    disableDownload,
    doctorRole,
    transactionsData,
    procedureList,
    doctorList,
    selectedDoctorId,
    consultationTypeValue,
    procedureTypeFilterValue,
    paymentStatus,
    paymentMethodValue,
    partialAmountValue,
    startDate,
    endDate,
    currentPage,
    totalCount,
    loader,
    transactionDownloadOption,
    handleAccountDetails,
    getTransactions,
    downloadReportApi,
    displaySearchFilter,
    displayTransactionDropdown,
    handleDefaultPayload,
    handleSelectReportType,
  } = props;

  const [popoverClose, setPopoverClose] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // Actions ===>

  const onPageChange = (val) => {
    addQuery(history, location, [API_FILTER_LIST.PAGENO], [`${val}`]);
    getTransactions({ [API_FILTER_LIST.PAGENO]: val });
    setPopoverClose(!popoverClose);
  };

  // <===

  // Display UI ===>

  const displayMyTransactionsHeader = () => {
    return (
      <MyTransactionsMainContentHeader
        transactionsSummary={transactionsSummary}
        userType={userType}
        doctorRole={doctorRole}
        clinicId={clinicId}
        sortOrder={sortOrder}
        disableDownload={disableDownload}
        procedureList={procedureList}
        doctorList={doctorList}
        selectedDoctorId={selectedDoctorId}
        consultationTypeValue={consultationTypeValue}
        procedureTypeFilterValue={procedureTypeFilterValue}
        paymentStatus={paymentStatus}
        paymentMethodValue={paymentMethodValue}
        partialAmountValue={partialAmountValue}
        startDate={startDate}
        endDate={endDate}
        transactionDownloadOption={transactionDownloadOption}
        handleAccountDetails={handleAccountDetails}
        getTransactions={getTransactions}
        downloadReportApi={downloadReportApi}
        displaySearchFilter={displaySearchFilter}
        displayTransactionDropdown={displayTransactionDropdown}
        handleDefaultPayload={handleDefaultPayload}
        handleSelectReportType={handleSelectReportType}
      />
    );
  };

  const displayMyTransactionsTable = () => {
    return (
      <MyTransactionsTable
        userType={userType}
        popoverClose={popoverClose}
        doctorRole={doctorRole}
        transactionsData={transactionsData}
        loader={loader}
      />
    );
  };

  const displayMyTransactionsFooter = () => {
    return (
      <MyTransactionsMainContentFooter
        transactionsData={transactionsData}
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={Number(DEFAULT_TRANSACTIONS_PAYLOAD.rows_per_page)}
        onPageChange={onPageChange}
      />
    );
  };

  // <===

  return (
    <div className="my-transactions-main-content-container">
      {displayMyTransactionsHeader()}
      <div className="mtmcc-table-container">
        {displayMyTransactionsTable()}
        {displayMyTransactionsFooter()}
      </div>
    </div>
  );
};

export default MyTransactionsMainContent;
